import React from 'react'
import { FastField, Field } from 'formik'
import FormikInput from '../FormikInput'
import FormikSelect, { Option } from '../FormikSelect'
import { customerUserRoles } from '../../utils/config'

type UserDrawerFormProps = {
  isSubmitting: boolean
  places: Option[]
  showCustomers: boolean
}

const UserDrawerForm: React.FC<UserDrawerFormProps> = (props) => {
  return (
    <div className="divide-y divide-gray-200 px-4 sm:px-6">
      <fieldset className="space-y-6 pt-6 pb-5" disabled={props.isSubmitting}>
        <Field
          name="role"
          component={FormikSelect}
          label="Role"
          options={[
            { label: 'Super Admin', value: customerUserRoles.superAdmin },
            { label: 'Admin', value: customerUserRoles.admin },
            { label: 'Manager', value: customerUserRoles.manager },
            { label: 'Operator', value: customerUserRoles.operator },
          ]}
        />

        <FastField type="text" name="displayName" component={FormikInput} label="Name" placeholder="User name" />

        <FastField type="email" name="email" component={FormikInput} label="Email" placeholder="user@email.com" />
      </fieldset>
      {props.places.length > 0 && props.showCustomers && (
        <fieldset className="space-y-6 pt-6 pb-5" disabled={props.isSubmitting}>
          <div className="flex flex-col">
            <label className="mb-2 text-base font-semibold leading-6">Assign Locations</label>
            <label className="text-sm font-normal leading-5 text-gray-500">
              If you’d like to limit access to specific locations you can specify access below.
            </label>
          </div>

          <Field name="places" component={FormikSelect} label="Assign Locations" isMulti options={props.places} />
        </fieldset>
      )}
    </div>
  )
}

export default UserDrawerForm
